'use client';

import { Container, Flex } from '@instamenu/ui-system-next';
import { UserMenu } from './user-menu';
import { Avocado } from '@instamenu/ui-icons';
import { headerStyle, container } from './Header.css';
import { Menu } from 'lucide-react';

export default function Header({
  isDesktop,
  setIsMobileOpen,
  setWidth,
  width,
}: {
  isDesktop: boolean;
  setIsMobileOpen: (isMobileOpen: boolean) => void;
  setWidth: (width: number) => void;
  width: number;
}) {
  const handleMenuClick = () => {
    if (isDesktop) {
      setWidth(360);
    } else {
      setIsMobileOpen(true);
    }
  };

  return (
    <header className={headerStyle}>
      <Container className={container}>
        {(!isDesktop || !width) && (
          <>
            <Menu style={{ cursor: 'pointer' }} onClick={handleMenuClick} size={24} />
            <Avocado width={24} height={24} />
          </>
        )}
        <Flex style={{ alignItems: 'center', justifyContent: 'flex-end', marginLeft: 'auto' }}>
          <UserMenu />
        </Flex>
      </Container>
    </header>
  );
}
